import { TranslateService } from 'ng2-translate';
import {NavController, ViewController, AlertController, LoadingController, NavParams} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";

@Component({
    templateUrl: 'personMsgView.html',
})
export class SysMsgViewPage {
    content: string;
    uid: string;
    title: string = this.translate.instant("SYS_MSG_VIEW_TITLE");

    constructor(public params: NavParams, 
        private translate: TranslateService,
        public loadingCtrl: LoadingController, private viewCtrl: ViewController, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService) {
        this.uid = params.get("id");
        this.initData();
    }

    initData() {
        let postData = {
            id: this.uid
        };
        this.userService.sysMsgBeanInfo(postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.content = data["sysmsg"]["content"];
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/personMsgView/sysMsgView.ts